export default __webpack_public_path__ + "static/media/trans_deposit.197fc1d9.svg";